import { PageLink } from 'assets/layout/core'

export const breadcrumbView: PageLink[] = [
  {
    title: 'Cardápios',
    path: '/commercial/menuFoods',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
